import { Modal } from '@design-system/components/modal/modal';
import { UnsavedChangesModal as UnsavedChangesModalProps } from './pricing.model';

export const UnsavedChangesModal = ({
  isOpen,
  saving,
  onClose,
  onDiscard,
  onSave,
}: UnsavedChangesModalProps) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    title="Save your changes?"
    description="You have unsaved changes. If you leave now, your edits will be lost."
    modalClassName="w-full md:w-[500px]"
    primaryCta={{
      caption: saving ? 'Saving...' : 'Save changes',
      onClick: onSave,
      state: saving ? 'disabled' : undefined,
    }}
    secondaryCta={{
      caption: 'Discard changes',
      onClick: onDiscard,
      state: saving ? 'disabled' : undefined,
    }}
  />
);
